import { Filter } from '@elementary/common-ui/services/gql/types';
import { MutationError } from '@elementary/common-ui/types/mutationTypes';
import { conditionalOperators, EMPTY_GROUP_TITLE } from 'shared/constants';
import {
  GroupTitleFormatters,
  Severity,
  SeverityFormField,
} from 'shared/types';

export const parseConditionalSeverity = (
  severity: Severity,
  errorIf?: string,
  warnIf?: string,
) => {
  const severityFormField: SeverityFormField = {
    type: severity.toLowerCase() as Severity,
  };

  if (!errorIf && !warnIf) {
    return severityFormField;
  }

  const sortedOperators = [...conditionalOperators].sort(
    (a, b) => b.length - a.length,
  );

  const errorOperator = sortedOperators.find((op) => errorIf?.includes(op));

  const warnOperator = sortedOperators.find((op) => warnIf?.includes(op));

  if (errorOperator) {
    severityFormField.conditionalError = {
      operator: errorOperator,
      value: Number(errorIf?.replace(errorOperator, '').trim()),
    };
  }

  if (warnOperator) {
    severityFormField.conditionalWarning = {
      operator: warnOperator,
      value: Number(warnIf?.replace(warnOperator, '').trim()),
    };
  }

  return severityFormField;
};

// Filter options report NULL values as an empty value, but `equals ['']` does
// not match NULL on the backend. `notEquals` matches NULL, so the empty group
// is fetched as "none of the other values".
export const getGroupValueFilter = (
  property: string,
  value: string,
  nonEmptyValues: string[],
): Filter =>
  value
    ? { property, operator: 'equals', value: [value] }
    : { property, operator: 'notEquals', value: nonEmptyValues };

export const formatGroupTitle = (
  titleFormatters: GroupTitleFormatters,
  columnId: string,
  value: string,
) => {
  if (!value) return EMPTY_GROUP_TITLE;
  const formatTitle = titleFormatters[columnId];
  return formatTitle ? formatTitle(value) : value;
};

export const isMutationError = (error: unknown): error is MutationError =>
  typeof error === 'object' && error != null && 'response' in error;
